import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Experience from './pages/Experience';
import Skills from './pages/Skills';
import Projects from './pages/Projects';
import Personal from './pages/Personal';
import Contact from './pages/Contact';
import Impact from './pages/Impact';
import Footer from './components/Footer';

function App() {
  const [viewMode, setViewMode] = useState('professional');
  // 'professional' or 'personal'

  return (
    <Router>
      <div className="app flex flex-col min-h-screen">
        <Navbar viewMode={viewMode} setViewMode={setViewMode} />
        <main className="flex-grow">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Home viewMode={viewMode} />} />
              <Route path="/experience" element={<Experience viewMode={viewMode} />} />
              <Route path="/skills" element={<Skills viewMode={viewMode} />} />
              <Route path="/projects" element={<Projects viewMode={viewMode} />} />
              <Route path="/impact" element={<Impact viewMode={viewMode} />} />
              <Route path="/personal" element={<Personal viewMode={viewMode} />} />
              <Route path="/contact" element={<Contact viewMode={viewMode} />} />
            </Routes>
          </AnimatePresence>
        </main>
        <Footer viewMode={viewMode} />
      </div>
    </Router>
  );
}

export default App;